import { render, staticRenderFns } from "./NewHomeYes.vue?vue&type=template&id=37c7fe6f"
import script from "./NewHomeYes.vue?vue&type=script&lang=js"
export * from "./NewHomeYes.vue?vue&type=script&lang=js"
import style0 from "./NewHomeYes.vue?vue&type=style&index=0&id=37c7fe6f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports